import React, { useState, useEffect, useCallback } from "react";
import { Refund, RefundOpt } from "../../types/Refund";
import { getAxios } from "../../utils/endpoints";
import { SelectChangeEvent } from "@mui/material";

export const useViewRefunds = () => {
    const [refunds, setRefunds] = useState<Refund[]>([]);
    const [statuses, setStatuses] = useState<RefundOpt[]>([]);
    const [searchForOpts, setSearchForOpts] = useState<RefundOpt[]>([]);

    const [status, setStatus] = useState<number>(0);
    const [searchMode, setSearchMode] = useState<number>(0);
    const [searchFor, setSearchFor] = useState<string>("");
    const [startIndex, setStartIndex] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(5);
    const [orderBy, setOrderBy] = useState<"asc" | "desc">("desc");
    const [total, setTotal] = useState<number>(0);

    const fetchSearchForOptions = async (): Promise<void> => {
        const response = await getAxios("/refund/search-for", "GET", undefined, {
            active: 1
        });

        const data: RefundOpt[] = await response.data;

        setSearchForOpts(data);
    }

    const fetchStatuses = async () => {
        const response = await getAxios("/refund/statuses", "GET");

        const data: RefundOpt[] = await response.data;

        setStatuses(data);
    }

    const onApplyFilters = async () => {
        const response = await getAxios("/refund", "GET", undefined, {
            PageSize: pageSize,
            StartIndex: startIndex,
            OrderBy: orderBy,
            SearchMode: searchMode,
            SearchFor: searchFor,
            StatusID: status
        });

        const data = await response.data;

        setRefunds(data.items);
        setTotal(data.totalRecordCount);
    }

    const fetchRefunds = useCallback(async () => {
        const response = await getAxios("/refund", "GET", undefined, {
            PageSize: pageSize,
            StartIndex: startIndex,
            OrderBy: orderBy,
            SearchMode: searchMode,
            SearchFor: searchFor,
            StatusID: status
        });

        const data = await response.data;

        setRefunds(data.items);
        setTotal(data.totalRecordCount);
    }, [startIndex, pageSize, orderBy]);

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;

        setSearchFor(value);
    }

    const onChangeSelect = (name: string, event: SelectChangeEvent<unknown>) => {
        const { value } = event.target;

        if (name === "status") {
            setStatus(value as number);
        } else {
            setSearchMode(value as number);
        }
    }

    const onPageChange = (newPage: number) => setStartIndex(newPage);
    const onPageSizeChange = (newPageSize: number) => setPageSize(newPageSize);


    useEffect(() => {
        fetchRefunds();
        fetchSearchForOptions();
        fetchStatuses();
    }, []);

    useEffect(() => {
        fetchRefunds();
    }, [fetchRefunds]);

    return {
        refunds,
        statuses,
        searchForOpts,
        pageSize,
        startIndex,
        searchFor,
        total,
        searchMode,
        status,
        onApplyFilters,
        onChange,
        onPageChange,
        onPageSizeChange,
        onChangeSelect
    }
}